import { Route } from 'react-router-dom';
import { GpoCustView } from '../../entities/custInfo/GpoCustView';

const bmsMdRoutes = [<Route path="/md/gpo-cust-view" element={<GpoCustView />} />];

export default bmsMdRoutes;
